import React from "react";
import { BlockMath, InlineMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";

const pick = (items) => items[Math.floor(Math.random() * items.length)];

export function generateTask() {
  const current = pick([-6, -4, -3, -2, 2, 3, 4, 6]);
  const q = pick([-3, -2, 2, 3]);
  const index = pick([1, 2, 3, 4]);
  return {
    type: "GeometricConsecutiveRatioTask",
    data: { index, current, next: current * q, q },
  };
}

export function renderTask({ data }) {
  return (
    <p>
      W ciągu geometrycznym <InlineMath math={`a_${data.index}=${data.current}`} /> oraz{" "}
      <InlineMath math={`a_{${data.index + 1}}=${data.next}`} />. Oblicz iloraz <InlineMath math="q" />.
    </p>
  );
}

export function renderInput(_task, userAnswer, onChange, disabled) {
  return <FractionInput label="q" value={userAnswer} onChange={onChange} disabled={disabled} />;
}

export function checkAnswer({ data }, userAnswer) {
  return Number.isFinite(userAnswer?.parsed) && Math.abs(userAnswer.parsed - data.q) < 0.01;
}

export function renderAnswer({ data }) {
  return <InlineMath math={`q=${data.q}`} />;
}

export function renderExplanation({ data }) {
  return (
    <div className="space-y-3">
      <p>Iloraz otrzymujemy, dzieląc kolejny wyraz przez poprzedni.</p>
      <BlockMath math={String.raw`q=\frac{a_{${data.index + 1}}}{a_${data.index}}=\frac{${data.next}}{${data.current}}=${data.q}`} />
    </div>
  );
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer?.raw) return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={`q=${userAnswer.raw}`} />;
}
